import React from 'react';
import BaseParameters from '..';

function MarginProfitParameters() {
    return (
        <BaseParameters paramGroup="Margin & Profitability Assumptions"/>
    );
}

export default MarginProfitParameters;
